import React from "react";

interface FilterProps extends React.HTMLAttributes<HTMLDivElement> {
  isSelected?: boolean;
}

const Filter: React.FC<FilterProps> = ({ children, isSelected, ...rest }) => {
  return (
    <>
      <div className={`filter ${isSelected && "selected"}`} {...rest}>
        {children}
      </div>
      <style jsx>{`
        .filter {
          padding: 12px 16px;
          border: 1px solid #e7e7e7;
          white-space: nowrap;
          cursor: pointer;
          margin: 0 8px 16px 0;

          &.selected {
            background: #191919;
            color: #ffffff;
          }
        }
        @media (max-width: 768px) {
          .plush-snackbar {
            width: 90%;
            bottom: 23px;
          }
        }
      `}</style>
    </>
  );
};

export default Filter;
